import { StyledText } from './styles/StyledText';

type TProps = {
  type: string;
  className?: string;
};

export const TransactionType = ({ type, className = 'type' }: TProps) => (
  <StyledText className={className} type={type}>
    {type}
  </StyledText>
);
